import { useEffect } from 'react';

const KLAVIYO_COMPANY_ID = 'WWHJbY';

export function KlaviyoForm(props: any) {
  useEffect(() => {
    const src = `https://static.klaviyo.com/onsite/js/${KLAVIYO_COMPANY_ID}/klaviyo.js`;

    const scriptIsOnPage = document.querySelectorAll(`script[src="${src}"]`).length > 0
    if(scriptIsOnPage) return null;

    const script = document.createElement('script');
    script.src = src
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div className={`klaviyo-form-${props.id}`}></div>;
}
